import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';
import * as moment from 'moment';
import { APIRequest, QueryParamsUtil, UserStore } from '@reverbdotcom/discovery-ui';
import Loading from '../shared/loading';
import * as Cookies from 'js-cookie';

const COOKIE_DISMISS_KEY = 'weekly_newsletter_dismiss';
const COOKIE_SUBMITTED_KEY = 'weekly_newsletter_submitted';
const EXPIRATION_DATE = new Date(moment().add(30, 'days'));

const ARTICLE_BODY_SELECTOR = '.blog-post__content';
const SCROLL_EVENT = 'scroll.email.signup';
const SCROLL_TOLERANCE = 25;

const AID_PARAM = '_aid';
const AID_VALUE = 'newsletter';

function surpressFromNewsLetter() {
  return QueryParamsUtil.getParamValue(AID_PARAM) === AID_VALUE;
}

function SuccessMessage(props) {
  return (
    <div className="align-center">
      <button
        type="submit"
        onClick={props.onClick}
        className="button button--orange"
      >
        {I18n.t('js.emailSignup.close')}
      </button>
    </div>
  );
}

SuccessMessage.propTypes = { onClick: PropTypes.func };

class EmailSignup extends React.Component {
  static get defaultProps() {
    return {
      userSignedup: Cookies.get(COOKIE_SUBMITTED_KEY),
      userDismissed: Cookies.get(COOKIE_DISMISS_KEY),
      linkedFromNewsLetter: surpressFromNewsLetter(),
      userEmail: null,
      signupUrl: null,
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      disableSubmit: false,
      dismissed: false,
      active: false,
      email: props.userEmail,
      title: I18n.t('js.emailSignup.default.title'),
      message: I18n.t('js.emailSignup.default.message'),
      analyticsFired: false,
    };

    this.onDismiss = this.onDismiss.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSetEmail = this.onSetEmail.bind(this);
    this.addWindowEvent = this.addWindowEvent.bind(this);
    this.success = this.success.bind(this);
    this.fail = this.fail.bind(this);
  }

  componentDidMount() {
    if (this.container) {
      this.addWindowEvent($(this.container));
    }
  }

  componentWillUnmount() {
    this.removeWindowEvent();
  }

  onDismiss() {
    if (!this.state.submitted) {
      Cookies.set(COOKIE_DISMISS_KEY, true, { expires: EXPIRATION_DATE });
    }

    this.setState({ dismissed: true });
    this.removeWindowEvent();
  }

  onSubmit(event) {
    event.preventDefault();

    if (this.state.email) {
      this.setState({ disableSubmit: true });

      Cookies.set(COOKIE_SUBMITTED_KEY, true);

      const params = {
        email: this.state.email,
      };
      if (this.showGdpr) {
        params.consented_to_gdpr = true;
      }
      const req = APIRequest.post(this.props.signupUrl, params);

      req.success(this.success);
      req.fail(this.fail);
    }

    return false;
  }

  onSetEmail(event) {
    this.setState({ email: event.target.value });
  }

  addWindowEvent() {
    // this callback was causing flaking karma tests
    // presumably due to some incomplete test setup
    // as a quick fix, we just won't execute this callback in test
    if (process.env.NODE_ENV === 'test') { return; }
    $(window).on(SCROLL_EVENT, () => {
      const articleHeight = $(ARTICLE_BODY_SELECTOR).innerHeight()
        - $(ARTICLE_BODY_SELECTOR).position().top;
      const scrollPosition = $(window).scrollTop();
      const percent = (scrollPosition / articleHeight) * 100;

      if (percent > SCROLL_TOLERANCE) {
        if (!this.state.analyticsFired) {
          this.setState({ analyticsFired: true });
        }

        this.setState({ active: true });
      } else {
        this.setState({ active: false });
      }
    });
  }

  removeWindowEvent() {
    $(window).off(SCROLL_EVENT);
  }

  updateFacebook() {
    const metaData = ({ content_name: 'mailing_list' });
    if (window.fbq) {
      window.fbq('track', 'Lead', metaData);
    }
  }

  success() {
    this.updateFacebook();

    this.setState({
      submitted: true,
      disableSubmit: false,
      title: I18n.t('js.emailSignup.submitted.title'),
      message: I18n.t('js.emailSignup.submitted.message'),
    });
  }

  fail(e) {
    let title;
    let message;

    if (e.status === 400) {
      title = I18n.t('js.emailSignup.invalid.title');
      message = I18n.t('js.emailSignup.invalid.message');
    } else {
      title = I18n.t('js.emailSignup.error.title');
      message = I18n.t('js.emailSignup.error.message');
    }

    this.setState({
      submitted: false,
      disableSubmit: false,
      title,
      message,
    });
  }

  display() {
    return {
      display: this.state.dismissed ? 'none' : 'block',
    };
  }

  get showGdpr() {
    return UserStore.getState().gdpr;
  }

  renderGdprTerms() {
    if (!this.showGdpr) { return null; }

    return (
      <div className="email-signup__terms">
        {I18n.t('js.emailSignup.gdprTerms', { buttonText: I18n.t('js.emailSignup.subscribeButton') })}
      </div>
    );
  }

  renderForm() {
    if (this.state.submitted) {
      return <SuccessMessage onClick={this.onDismiss} />;
    }

    return (
      <form onSubmit={this.onSubmit}>
        <div className="input-group">
          <input
            type="email"
            name="email"
            className="input-group__input"
            defaultValue={this.props.userEmail}
            onChange={this.onSetEmail}
            placeholder={I18n.t('js.emailSignup.inputEmailPlaceholder')}
            disabled={this.state.disableSubmit}
          />
          <button
            type="submit"
            disabled={this.state.disableSubmit}
            className="input-group__button button button--orange"
          >
            <Loading
              loaded={!this.state.disableSubmit}
              size="small"
              color="white"
            >
              {I18n.t('js.emailSignup.subscribeButton')}
            </Loading>
          </button>
        </div>
      </form>
    );
  }

  classNames() {
    return classNames({ 'email-signup': true, active: this.state.active });
  }

  render() {
    if (this.props.userSignedup) { return false; }
    if (this.props.userDismissed) { return false; }
    if (this.props.linkedFromNewsLetter) { return false; }

    return (
      <section ref={(el) => this.container = el} className={this.classNames()} style={this.display()}>
        <button className="email-signup__close-icon" onClick={this.onDismiss}>
          <i className="fa fa-times" />
        </button>
        <div className="email-signup__message-wrapper">
          <h2 className="email-signup__message-title">{this.state.title}</h2>
          <p className="email-signup__message-subtitle">{this.state.message}</p>
        </div>
        <div className="email-signup__form-wrapper">
          {this.renderForm()}
          {this.renderGdprTerms()}
        </div>
      </section>
    );
  }
}

EmailSignup.propTypes = {
  userSignedup: PropTypes.bool,
  userDismissed: PropTypes.bool,
  linkedFromNewsLetter: PropTypes.bool,
  signupUrl: PropTypes.string,
  analyticsContext: PropTypes.string,
};

export default EmailSignup;



// WEBPACK FOOTER //
// ./javascripts/components/email_signup/email_signup.jsx